import { ChevronDown } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import BackBG from "../assets/images/icons/box.svg";
import DropdownCountry from "../components/DropdownCountry";
import ProfileService from "../services/profile.service";
import Toaster from "../components/toaster";
import { useFormik } from "formik";
import Loader from "../assets/images/icons/loader.gif";

const countryCodes = [
  { code: "+1", country: "United States" },
  { code: "+44", country: "United Kingdom" },
  { code: "+91", country: "India" },
  { code: "+61", country: "Australia" },
  { code: "+81", country: "Japan" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+55", country: "Brazil" },
  { code: "+86", country: "China" },
  { code: "+34", country: "Spain" },
  { code: "+39", country: "Italy" },
  { code: "+7", country: "Russia" },
  { code: "+82", country: "South Korea" },
  { code: "+971", country: "United Arab Emirates" },
  { code: "+46", country: "Sweden" },
  { code: "+31", country: "Netherlands" },
  { code: "+41", country: "Switzerland" },
  { code: "+47", country: "Norway" },
  { code: "+48", country: "Poland" },
  { code: "+32", country: "Belgium" },
  { code: "+52", country: "Mexico" },
  { code: "+54", country: "Argentina" },
  { code: "+60", country: "Malaysia" },
  { code: "+65", country: "Singapore" },
  { code: "+27", country: "South Africa" },
  { code: "+20", country: "Egypt" },
  { code: "+30", country: "Greece" },
  { code: "+92", country: "Pakistan" },
  { code: "+98", country: "Iran" },
  { code: "+66", country: "Thailand" },
  { code: "+63", country: "Philippines" },
  { code: "+62", country: "Indonesia" },
  { code: "+64", country: "New Zealand" },
  { code: "+90", country: "Turkey" },
  { code: "+351", country: "Portugal" },
  { code: "+34", country: "Israel" },
  { code: "+372", country: "Estonia" },
  { code: "+47", country: "Denmark" },
  { code: "+91", country: "Malaysia" },
  { code: "+357", country: "Greece" },
];

function calculateAge(dateOfBirth) {
  const [day, month, year] = dateOfBirth.split("-").map(Number);
  const birthDate = new Date(year, month - 1, day);
  const age = new Date().getFullYear() - birthDate.getFullYear();
  return (
    age -
    (new Date() < new Date(new Date().getFullYear(), month - 1, day) ? 1 : 0)
  );
}

const MyProfile = () => {
  const [selectedCountry, setSelectedCountry] = useState(countryCodes[0]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [editMode, setEditMode] = useState(false);
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [profileData, setProfileData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOption2, setSelectedOption2] = useState("");
  const [selectedOption3, setSelectedOption3] = useState("");
  const [selectedOption4, setSelectedOption4] = useState("");
  const [selectedOption5, setSelectedOption5] = useState("");

  const handleOptionSelect = (option) => {
    formik.setFieldValue("country", option.value);
    setSelectedOption(option.label);
  };
  const handleOptionSelect2 = (option2) => {
    formik.setFieldValue("position", option2.option);
    setSelectedOption2(option2.label);
  };
  const handleOptionSelect3 = (option3) => {
    formik.setFieldValue("favoriteGame", option3.label);
    setSelectedOption3(option3.label);
  };
  const handleOptionSelect4 = (option4) => {
    formik.setFieldValue("mainSkillsToDevelop", option4.label);
    setSelectedOption4(option4.label);
  };
  const handleOptionSelect5 = (option5) => {
    formik.setFieldValue("favoriteMilestone", option5.label);
    setSelectedOption5(option5.label);
  };

  const options = [
    { value: "ABW", label: "Aruba" },
    { value: "AFG", label: "Afghanistan" },
    { value: "AGO", label: "Angola" },
    { value: "AIA", label: "Anguilla" },
    { value: "ALA", label: "Åland Islands" },
    { value: "ALB", label: "Albania" },
    { value: "AND", label: "Andorra" },
    { value: "ARE", label: "United Arab Emirates" },
    { value: "ARG", label: "Argentina" },
    { value: "ARM", label: "Armenia" },
    { value: "ASM", label: "American Samoa" },
    { value: "ATA", label: "Antarctica" },
    { value: "ATF", label: "French Southern Territories" },
    { value: "ATG", label: "Antigua and Barbuda" },
    { value: "AUS", label: "Australia" },
    { value: "AUT", label: "Austria" },
    { value: "AZE", label: "Azerbaijan" },
    { value: "BDI", label: "Burundi" },
    { value: "BEL", label: "Belgium" },
    { value: "BEN", label: "Benin" },
    { value: "BES", label: "Bonaire, Sint Eustatius and Saba" },
    { value: "BFA", label: "Burkina Faso" },
    { value: "BGD", label: "Bangladesh" },
    { value: "BGR", label: "Bulgaria" },
    { value: "BHR", label: "Bahrain" },
    { value: "BHS", label: "Bahamas" },
    { value: "BIH", label: "Bosnia and Herzegovina" },
    { value: "BLM", label: "Saint Barthélemy" },
    { value: "BLR", label: "Belarus" },
    { value: "BLZ", label: "Belize" },
    { value: "BMU", label: "Bermuda" },
    { value: "BOL", label: "Bolivia" },
    { value: "BRA", label: "Brazil" },
    { value: "BRB", label: "Barbados" },
    { value: "BRN", label: "Brunei Darussalam" },
    { value: "BTN", label: "Bhutan" },
    { value: "BVT", label: "Bouvet Island" },
    { value: "BWA", label: "Botswana" },
    { value: "CAF", label: "Central African Republic" },
    { value: "CAN", label: "Canada" },
    { value: "CCK", label: "Cocos (Keeling) Islands" },
    { value: "CHE", label: "Switzerland" },
    { value: "CHL", label: "Chile" },
    { value: "CHN", label: "China" },
    { value: "CIV", label: "Côte d'Ivoire" },
    { value: "CMR", label: "Cameroon" },
    { value: "COD", label: "Congo (Democratic Republic of the)" },
    { value: "COG", label: "Congo" },
    { value: "COK", label: "Cook Islands" },
    { value: "COL", label: "Colombia" },
    { value: "COM", label: "Comoros" },
    { value: "CPV", label: "Cabo Verde" },
    { value: "CRI", label: "Costa Rica" },
    { value: "CUB", label: "Cuba" },
    { value: "CUW", label: "Curaçao" },
    { value: "CXR", label: "Christmas Island" },
    { value: "CYM", label: "Cayman Islands" },
    { value: "CYP", label: "Cyprus" },
    { value: "CZE", label: "Czechia" },
    { value: "DEU", label: "Germany" },
    { value: "DJI", label: "Djibouti" },
    { value: "DMA", label: "Dominica" },
    { value: "DNK", label: "Denmark" },
    { value: "DOM", label: "Dominican Republic" },
    { value: "DZA", label: "Algeria" },
    { value: "ECU", label: "Ecuador" },
    { value: "EGY", label: "Egypt" },
    { value: "ERI", label: "Eritrea" },
    { value: "ESH", label: "Western Sahara" },
    { value: "ESP", label: "Spain" },
    { value: "EST", label: "Estonia" },
    { value: "ETH", label: "Ethiopia" },
    { value: "FIN", label: "Finland" },
    { value: "FJI", label: "Fiji" },
    { value: "FLK", label: "Falkland Islands" },
    { value: "FRA", label: "France" },
    { value: "FRO", label: "Faroe Islands" },
    { value: "FSM", label: "Micronesia" },
    { value: "GAB", label: "Gabon" },
    { value: "GBR", label: "United Kingdom" },
    { value: "GEO", label: "Georgia" },
    { value: "GGY", label: "Guernsey" },
    { value: "GHA", label: "Ghana" },
    { value: "GIB", label: "Gibraltar" },
    { value: "GIN", label: "Guinea" },
    { value: "GLP", label: "Guadeloupe" },
    { value: "GMB", label: "Gambia" },
    { value: "GNB", label: "Guinea-Bissau" },
    { value: "GNQ", label: "Equatorial Guinea" },
    { value: "GRC", label: "Greece" },
    { value: "GRD", label: "Grenada" },
    { value: "GRL", label: "Greenland" },
    { value: "GTM", label: "Guatemala" },
    { value: "GUF", label: "French Guiana" },
    { value: "GUM", label: "Guam" },
    { value: "GUY", label: "Guyana" },
    { value: "HKG", label: "Hong Kong" },
    { value: "HMD", label: "Heard Island and McDonald Islands" },
    { value: "HND", label: "Honduras" },
    { value: "HRV", label: "Croatia" },
    { value: "HTI", label: "Haiti" },
    { value: "HUN", label: "Hungary" },
    { value: "IDN", label: "Indonesia" },
    { value: "IMN", label: "Isle of Man" },
    { value: "IND", label: "India" },
    { value: "IOT", label: "British Indian Ocean Territory" },
    { value: "IRL", label: "Ireland" },
    { value: "IRN", label: "Iran" },
    { value: "IRQ", label: "Iraq" },
    { value: "ISL", label: "Iceland" },
    { value: "ISR", label: "Israel" },
    { value: "ITA", label: "Italy" },
    { value: "JAM", label: "Jamaica" },
    { value: "JEY", label: "Jersey" },
    { value: "JOR", label: "Jordan" },
    { value: "JPN", label: "Japan" },
    { value: "KAZ", label: "Kazakhstan" },
    { value: "KEN", label: "Kenya" },
    { value: "KGZ", label: "Kyrgyzstan" },
    { value: "KHM", label: "Cambodia" },
    { value: "KIR", label: "Kiribati" },
    { value: "KNA", label: "Saint Kitts and Nevis" },
    { value: "KOR", label: "South Korea" },
    { value: "KWT", label: "Kuwait" },
    { value: "LAO", label: "Laos" },
    { value: "LBN", label: "Lebanon" },
    { value: "LBR", label: "Liberia" },
    { value: "LBY", label: "Libya" },
    { value: "LCA", label: "Saint Lucia" },
    { value: "LIE", label: "Liechtenstein" },
    { value: "LKA", label: "Sri Lanka" },
    { value: "LSO", label: "Lesotho" },
    { value: "LTU", label: "Lithuania" },
    { value: "LUX", label: "Luxembourg" },
    { value: "LVA", label: "Latvia" },
    { value: "MAC", label: "Macao" },
    { value: "MAF", label: "Saint Martin (French part)" },
    { value: "MAR", label: "Morocco" },
    { value: "MCO", label: "Monaco" },
    { value: "MDA", label: "Moldova" },
    { value: "MDG", label: "Madagascar" },
    { value: "MDV", label: "Maldives" },
    { value: "MEX", label: "Mexico" },
    { value: "MHL", label: "Marshall Islands" },
    { value: "MKD", label: "North Macedonia" },
    { value: "MLI", label: "Mali" },
    { value: "MLT", label: "Malta" },
    { value: "MMR", label: "Myanmar" },
    { value: "MNE", label: "Montenegro" },
    { value: "MNG", label: "Mongolia" },
    { value: "MNP", label: "Northern Mariana Islands" },
    { value: "MOZ", label: "Mozambique" },
    { value: "MRT", label: "Mauritania" },
    { value: "MSR", label: "Montserrat" },
    { value: "MTQ", label: "Martinique" },
    { value: "MUS", label: "Mauritius" },
    { value: "MWI", label: "Malawi" },
    { value: "MYS", label: "Malaysia" },
    { value: "MYT", label: "Mayotte" },
    { value: "NAM", label: "Namibia" },
    { value: "NCL", label: "New Caledonia" },
    { value: "NER", label: "Niger" },
    { value: "NFK", label: "Norfolk Island" },
    { value: "NGA", label: "Nigeria" },
    { value: "NIC", label: "Nicaragua" },
    { value: "NIU", label: "Niue" },
    { value: "NLD", label: "Netherlands" },
    { value: "NOR", label: "Norway" },
    { value: "NPL", label: "Nepal" },
    { value: "NRU", label: "Nauru" },
    { value: "NZL", label: "New Zealand" },
    { value: "OMN", label: "Oman" },
    { value: "PAK", label: "Pakistan" },
    { value: "PAN", label: "Panama" },
    { value: "PCN", label: "Pitcairn" },
    { value: "PER", label: "Peru" },
    { value: "PHL", label: "Philippines" },
    { value: "PLW", label: "Palau" },
    { value: "PNG", label: "Papua New Guinea" },
    { value: "POL", label: "Poland" },
    { value: "PRI", label: "Puerto Rico" },
    { value: "PRK", label: "North Korea" },
    { value: "PRT", label: "Portugal" },
    { value: "PRY", label: "Paraguay" },
    { value: "PSE", label: "Palestine" },
    { value: "PYF", label: "French Polynesia" },
    { value: "QAT", label: "Qatar" },
    { value: "REU", label: "Réunion" },
    { value: "ROU", label: "Romania" },
    { value: "RUS", label: "Russia" },
    { value: "RWA", label: "Rwanda" },
    { value: "SAU", label: "Saudi Arabia" },
    { value: "SDN", label: "Sudan" },
    { value: "SEN", label: "Senegal" },
    { value: "SGP", label: "Singapore" },
    { value: "SGS", label: "South Georgia and the South Sandwich Islands" },
    { value: "SHN", label: "Saint Helena, Ascension and Tristan da Cunha" },
    { value: "SJM", label: "Svalbard and Jan Mayen" },
    { value: "SLB", label: "Solomon Islands" },
    { value: "SLE", label: "Sierra Leone" },
    { value: "SLV", label: "El Salvador" },
    { value: "SMR", label: "San Marino" },
    { value: "SOM", label: "Somalia" },
    { value: "SPM", label: "Saint Pierre and Miquelon" },
    { value: "SRB", label: "Serbia" },
    { value: "SSD", label: "South Sudan" },
    { value: "STP", label: "Sao Tome and Principe" },
    { value: "SUR", label: "Suriname" },
    { value: "SVK", label: "Slovakia" },
    { value: "SVN", label: "Slovenia" },
    { value: "SWE", label: "Sweden" },
    { value: "SWZ", label: "Eswatini" },
    { value: "SXM", label: "Sint Maarten (Dutch part)" },
    { value: "SYC", label: "Seychelles" },
    { value: "SYR", label: "Syria" },
    { value: "TCA", label: "Turks and Caicos Islands" },
    { value: "TCD", label: "Chad" },
    { value: "TGO", label: "Togo" },
    { value: "THA", label: "Thailand" },
    { value: "TJK", label: "Tajikistan" },
    { value: "TKL", label: "Tokelau" },
    { value: "TKM", label: "Turkmenistan" },
    { value: "TLS", label: "Timor-Leste" },
    { value: "TON", label: "Tonga" },
    { value: "TTO", label: "Trinidad and Tobago" },
    { value: "TUN", label: "Tunisia" },
    { value: "TUR", label: "Turkey" },
    { value: "TUV", label: "Tuvalu" },
    { value: "TWN", label: "Taiwan" },
    { value: "TZA", label: "Tanzania" },
    { value: "UGA", label: "Uganda" },
    { value: "UKR", label: "Ukraine" },
    { value: "UMI", label: "United States Minor Outlying Islands" },
    { value: "URY", label: "Uruguay" },
    { value: "USA", label: "United States" },
    { value: "UZB", label: "Uzbekistan" },
    { value: "VAT", label: "Holy See" },
    { value: "VCT", label: "Saint Vincent and the Grenadines" },
    { value: "VEN", label: "Venezuela" },
    { value: "VGB", label: "Virgin Islands (British)" },
    { value: "VIR", label: "Virgin Islands (U.S.)" },
    { value: "VNM", label: "Vietnam" },
    { value: "VUT", label: "Vanuatu" },
    { value: "WLF", label: "Wallis and Futuna" },
    { value: "WSM", label: "Samoa" },
    { value: "YEM", label: "Yemen" },
    { value: "ZAF", label: "South Africa" },
    { value: "ZMB", label: "Zambia" },
    { value: "ZWE", label: "Zimbabwe" },
  ];

  /* const option2 = [
    { label: "Goalkeeper", option: "Goalkeeper" },
    { label: "Centre-Back", option: "Centre-back" },
    { label: "Running Back", option: "Running back" },
    { label: "Full Back", option: "Fullback" },
    { label: "Defensive Midfielder", option: "Defensive midfielder" },
    { label: "Midfielders", option: "Midfielders" },
    { label: "Wide Receiver", option: "Wide receiver" },
    { label: "Tight End", option: "Tight end" },
  ]; */
  const option2 = [
    { label: "Goalkeeper", option: "Goalkeeper" },
    { label: "Defender", option: "Defender" },
    { label: "Midfielder", option: "Midfielder" },
    { label: "Attacker", option: "Attacker" },
  ];

  const option3 = [
    { label: "Number", value: "number" },
    { label: "Color", value: "color" },
    { label: "Shapes", value: "shapes" },
    { label: "Binary", value: "binary" },
    { label: "Make It 9", value: "make it 9" },
    { label: "Recall", value: "recall" },
    { label: "Stroop", value: "stroop" },
    { label: "Calculator", value: "calculator" },
    { label: "Start With 1", value: "start with 1" },
    { label: "Challenge", value: "challenge" },
  ];

  const option4 = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
  ];

  const option5 = [
    { label: "QUICKFEET", value: "QUICKFEET" },
    { label: "Visionair", value: "Visionair" },
    { label: "Geek", value: "Geek" },
    { label: "QUICKFEET Challege", value: "QUICKFEET Challege" },
  ];

  useEffect(() => {
    setSelectedOption("Select Country");
  }, []);
  useEffect(() => {
    setSelectedOption2("Select Position");
  }, []);
  useEffect(() => {
    setSelectedOption3("Select Game");
  }, []);
  useEffect(() => {
    setSelectedOption4("Select Skill Develop");
  }, []);
  useEffect(() => {
    setSelectedOption5("Select Milestone");
  }, []);

  const handleCountrySelect = (country) => {
    formik.setFieldValue("countryCode", country?.code);
    setSelectedCountry(country);
    setIsOpen(false);
  };

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const toggleEditMode = () => {
    setEditMode(!editMode);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const formik = useFormik({
    initialValues: {
      username: "",
      mobileNumber: "",
      playername: "",
      age: "",
      country: "",
      clubName: "",
      position: "",
      favoriteGame: "",
      countryCode: "",
      mainSkillsToDevelop: "",
      favoriteMilestone: "",
      email: "",
    },
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const response = await ProfileService.updateProfile(values);
        if (response) {
          Toaster("success", response.data.message);
          getProfile();
        }
      } catch (error) {
        Toaster("error", error.message);
      } finally {
        setIsLoading(false);
      }
    },
  });

  const getProfile = async () => {
    try {
      setIsLoading(true);
      const response = await ProfileService.getProfile();
      const result = { ...response.data.data, ...response.data.userData };
      setProfileData(result);
      localStorage.setItem("favoriteMilestone", result.favoriteMilestone);
      formik.setFieldValue("username", result.username);
      formik.setFieldValue("mobileNumber", result.mobileNumber);
      formik.setFieldValue("email", result.email);
      formik.setFieldValue("playername", result.playername);
      if (result?.dateOfBirth) {
        setDateOfBirth(result?.dateOfBirth);
      }
      if (result.countryCode) {
        const code = countryCodes?.find(
          (res) => (res.code = result.countryCode)
        );
        setSelectedCountry(code);
      }
      if (result.country) {
        const code = options?.find((res) => (res.value = result.country));
        setSelectedOption(code?.label);
      }
      if (result.favoriteGame) {
        const code = option3?.find((res) => (res.label = result.favoriteGame));
        setSelectedOption3(code?.label);
      }
      if (result.position) {
        const code = option2?.find((res) => (res.label = result.position));
        setSelectedOption2(code?.label);
      }
      if (result.mainSkillsToDevelop) {
        const code = option4?.find(
          (res) => (res.label = result.mainSkillsToDevelop)
        );
        setSelectedOption4(code?.label);
      }
      if (result.favoriteMilestone) {
        const code = option5?.find(
          (res) => (res.label = result.favoriteMilestone)
        );
        setSelectedOption5(code?.label);
      }

      formik.setFieldValue("clubName", result.clubName);
      formik.setFieldValue("age", result.age);
      formik.setFieldValue("favoriteMilestone", result.favoriteMilestone);
      formik.setFieldValue("mainSkillsToDevelop", result.mainSkillsToDevelop);
      formik.setFieldValue("favoriteGame", result.favoriteGame);
      formik.setFieldValue("position", result.position);
      formik.setFieldValue("country", result.country);
      // formik.setFieldValue("dateOfBirth", result.dateOfBirth);
    } catch (error) {
      Toaster("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  return (
    <>
      <div className="mb-5 flex items-center justify-between">
        <Link to="/" className="relative cursor-pointer">
          <div className="max-h-20">
            <img
              src={BackBG}
              alt="Back Background"
              className="w-full h-full max-h-10"
            />
          </div>
          <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold text-base">
            Back
          </span>
        </Link>
      </div>
      {isLoading ? (
        <div className="flex justify-center items-center">
          <img src={Loader} alt="Loader" className="w-16 h-16" />
        </div>
      ) : (
        <div className="mt-6 text-white max-w-5xl mx-auto">
          <form onSubmit={formik.handleSubmit}>
            <div className="flex items-center justify-between text-white max-w-5xl mb-6">
              <h3 className="text-xl font-medium">Profile Details</h3>
              <button
                type={editMode ? "button" : "submit"}
                className={`p-2 w-32 ${
                  editMode ? "bg-primary" : "bg-primary"
                } text-white rounded-lg text-center`}
                onClick={toggleEditMode}
              >
                {editMode ? "Save" : "Edit Profile"}
              </button>
            </div>

            <div className="grid tab:grid-cols-2 gap-10">
              <div className="grid">
                <label style={{ fontWeight: "400px" }}>User Name</label>
                <input
                  type="text"
                  disabled={!editMode}
                  name="username"
                  value={formik.values.username}
                  onChange={formik.handleChange}
                />
              </div>
              <div className="grid">
                <label style={{ fontWeight: "400px" }}>Player Name</label>
                <input
                  type="text"
                  disabled={!editMode}
                  name="playername"
                  value={formik.values.playername}
                  onChange={formik.handleChange}
                />
              </div>
              <div className="grid">
                <label style={{ fontWeight: "400px" }}>Age</label>
                <input
                  type="text"
                  disabled={!editMode}
                  name="age"
                  value={formik.values.age}
                  onChange={formik.handleChange}
                  // value={calculateAge(dateOfBirth)}
                />
              </div>
              <div className="grid">
                <label style={{ fontWeight: "400px" }}>Country</label>
                <DropdownCountry
                  label={selectedOption}
                  options={options}
                  onSelect={handleOptionSelect}
                  disabled={!editMode}
                />
              </div>
              <div className="grid">
                <label style={{ fontWeight: "400px" }}>Club Name</label>
                <input
                  type="text"
                  disabled={!editMode}
                  name="clubName"
                  value={formik.values.clubName}
                  onChange={formik.handleChange}
                />
              </div>
              <div className="grid">
                <label style={{ fontWeight: "400px" }}>Position</label>
                <DropdownCountry
                  label={selectedOption2}
                  options={option2}
                  onSelect={handleOptionSelect2}
                  disabled={!editMode}
                />
              </div>
              <div className="grid">
                <label style={{ fontWeight: "400px" }}>Select Favorite Game</label>
                <DropdownCountry
                  label={selectedOption3}
                  options={option3}
                  onSelect={handleOptionSelect3}
                  disabled={!editMode}
                />
              </div>
              <div className="grid">
                <label style={{ fontWeight: "400px" }}>Select Main Skill to Develop</label>
                <DropdownCountry
                  label={selectedOption4}
                  options={option4}
                  onSelect={handleOptionSelect4}
                  disabled={!editMode}
                />
              </div>
              <div className="grid">
                <label style={{ fontWeight: "400px" }}>Select Milestone</label>
                <DropdownCountry
                  label={selectedOption5}
                  options={option5}
                  onSelect={handleOptionSelect5}
                  disabled={!editMode}
                />
              </div>
              <div className="grid">
                <label style={{ fontWeight: "400px" }}>Email</label>
                <input
                  type="email"
                  disabled={!editMode}
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />
              </div>
              <div className="grid">
                <label style={{ fontWeight: "400px" }}>Phone Number</label>
                <div className="relative">
                  <div
                    className="absolute top-1/2 -translate-y-1/2 left-0 h-fit pr-2 border-r border-black/30"
                    ref={dropdownRef}
                  >
                    <button
                      type="button"
                      className="inline-flex justify-between items-center w-14 rounded-l-md text-sm font-medium pl-3"
                      onClick={toggleDropdown}
                      disabled={!editMode}
                    >
                      {selectedCountry.code}
                      <ChevronDown className="h-4 w-4 ml-1 text-white" />
                    </button>
                    {isOpen && editMode && (
                      <div className="absolute bottom-10 z-10 w-60 mt-2 max-w-56 bg-black/90 text-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none max-h-56 overflow-y-auto">
                        <div
                          className="py-1"
                          role="menu"
                          aria-orientation="vertical"
                        >
                          {countryCodes?.map((country) => (
                            <button
                              key={country.code}
                              className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900 text-white"
                              role="menuitem"
                              onClick={() => handleCountrySelect(country)}
                            >
                              {country.code} {country.country}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    <input
                      type="number"
                      className="pl-[70px] w-full" // Add left padding here
                      disabled={!editMode}
                      name="mobileNumber"
                      value={formik.values.mobileNumber}
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default MyProfile;
